module.exports = __webpack_public_path__ + "img/icon-edit-light-gray.28cfa5ea.svg";